import api from "../api/axios";

  

const SaleListService = {
 
    getSales: async (params) => {
        const res = await api.get( "sales/get-sales",{ params });
        return res.data.data || res.data;
    },
    getPayments: async (saleId) => {
        const res = await api.get( `sales/get-payments/${saleId}`);
        return res.data.data || res.data;
    },
    addPayment: async (saleId, payload) => {
    const res = await api.post(`/sales/${saleId}/payments`, payload);
    return res.data;
  }, 
    getSaleDetail: async (saleId) => {
        const res = await api.get(`sales/get-sale-detail/${saleId}`);
        return res.data.data || res.data;
    },
 
};

export default SaleListService;
